module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJnbHlwaGljb25zLWhhbGZsaW5ncy1yZWd1bGFyLnN2Zz85MjA1YjdjMTI0ZDJiYjgyMTcyZmM2YjJlMWJhZmQwOSI7"


//////////////////
// WEBPACK FOOTER
// ./portal/css/kiss/fonts/font-kiss/fonts/glyphicons/glyphicons-halflings-regular.svg
// module id = 308
// module chunks = 9